"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const getContent_1 = require("../../helpers/getContent");
const getState_1 = require("../../helpers/getState");
function isAllQuestionSubmitted(content, states, assignmentCardId, userId) {
    try {
        const currentContent = getContent_1.getContentByContentId(content, assignmentCardId);
        const childrenStates = getState_1.getChildrenStatesForContentByUserId(states, currentContent, userId);
        const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
        let allQuestionsSubmitted = true;
        for (const childContent of currentContent.children) {
            const childContentId = childContent._id;
            const childState = childrenStatesByContentId[childContentId];
            if (!childState.actualSubmit && childContent.contributeToCompleteStatus) {
                allQuestionsSubmitted = false;
                break;
            }
        }
        return allQuestionsSubmitted;
    }
    catch (error) {
        throw new Error('Error in isAllQuestionSubmitted ' + error);
    }
}
exports.default = isAllQuestionSubmitted;
//# sourceMappingURL=isAllQuestionSubmitted.js.map